import * as z from "zod";
import { promotionAgendaItemSchema } from "./items/promotion";

export { TeamCalendarEntryAgendaItemType } from "./agenda-item-type";
export { promotionAgendaItemSchema } from "./items/promotion";
export type { PromotionAgendaItem } from "./items/promotion";

const TeamCalendarEntryAgendaItemSchema_ = z.discriminatedUnion("type", [
  promotionAgendaItemSchema,
]);

export type TeamCalendarEntryAgendaItem = z.infer<
  typeof TeamCalendarEntryAgendaItemSchema_
>;

export const TeamCalendarEntryAgendaItemSchema: z.ZodType<TeamCalendarEntryAgendaItem> =
  TeamCalendarEntryAgendaItemSchema_;
